import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';

export interface DeleteChatDialogData {
  mode: 'single' | 'all';
  chatTopic?: string;
}

@Component({
  selector: 'app-delete-chat-dialog',
  templateUrl: './delete-chat-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BicPopupComponent, BicButtonComponent],
})
export class DeleteChatDialogComponent {
  data = inject<DeleteChatDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<DeleteChatDialogComponent>>(MatDialogRef);

  get title(): string {
    return this.data.mode === 'all' ? 'Alle Chats löschen?' : 'Chat löschen?';
  }

  get message(): string {
    if (this.data.mode === 'all') {
      return 'Möchten Sie wirklich alle Chats unwiderruflich löschen? Alle Nachrichten und Dateien gehen dabei verloren.';
    }
    return `Möchten Sie den Chat "${this.data.chatTopic}" wirklich löschen? Alle Nachrichten und Dateien gehen dabei verloren.`;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}

